<ng-template #templateActionsOutside>
  <ng-content select="[sectionActionsOutside]"></ng-content>
</ng-template>
<ng-template #templateActionsInside>
  <ng-content select="[sectionActionsInside]"></ng-content>
</ng-template>

<div
  class="section-container"
  [style.--gallery-background-color]="section().layout_background_color || theme().layout_page.background_color"
  [style.background-color]="section().layout_background_color"
  [class.first-padding]="index === 0 && !!theme().cover.design"
  [class.no-hover]="!galleryPermissions().can_edit"
  [class.dark-gallery-background]="darkBackground"
  appInferredHover="section-{{ section().id }}"
  (onInferredHoverChange)="inferredHover = $event"
  (mouseover)="hover = true"
  (mouseleave)="hover = false"
>
  @if (galleryPermissions().can_edit && isDesktop) {
    <app-add-section
      [darkBackgroundColor]="darkBackground"
      [backgroundColor]="section().layout_background_color || theme().layout_page.background_color"
      [gallery]="gallery"
      [visible]="hover || inferredHover"
      (onOpen)="addSection.emit(0)"
    ></app-add-section>
  }

  <div
    class="section-content v-padding-{{ section().vertical_padding ?? theme().section.vertical_padding }}"
    appStickyContainer
    #sectionContainer
  >
    @if (galleryPermissions().can_edit) {
      @if (isDesktop) {
        <app-sticky
          [container]="sectionContainer"
          class="spaced-button-group-container"
          [paddingX]="10"
          [getPaddingY]="getPaddingY(sectionContainer, sticky)"
          [offsetTop]="64 + 10 - targetSpace"
          [stickTo]="'top'"
        >
          <div class="sticky-container" #sticky>
            @if (outsideActions) {
              <div class="spaced-button-group with-shadow spaced-button-group-round small vertical">
                <ng-container *ngTemplateOutlet="templateActionsOutside"></ng-container>
              </div>
            }
            @if (insideActions) {
              <div class="spaced-button-group with-shadow spaced-button-group-round small vertical">
                <ng-container *ngTemplateOutlet="templateActionsInside"></ng-container>
                <div class="spaced-button-group-item">
                  <button
                    appButton
                    name="delete"
                    location="section-container"
                    [iconButton]="true"
                    color="simple"
                    height="1"
                    shape="round"
                    appTooltip="Delete"
                    toolTipOrigin="left"
                    class="delete-button"
                    (click)="deleteSection()"
                  >
                    <app-svg src="/assets/icons/trash.svg"></app-svg>
                  </button>
                </div>
              </div>
            }

            @if (canMoveUp() || canMoveDown()) {
              <div class="spaced-button-group with-shadow spaced-button-group-round small vertical">
                <div class="spaced-button-group-item">
                  <button
                    appButton
                    name="move-up"
                    location="section-container"
                    [iconButton]="true"
                    color="simple"
                    height="1"
                    shape="round"
                    appTooltip="Move Up"
                    toolTipOrigin="left"
                    (click)="moveUp()"
                    [class.disabled]="!canMoveUp()"
                  >
                    <app-svg src="/assets/icons/chevron-up.svg"></app-svg>
                  </button>
                  <button
                    appButton
                    name="move-down"
                    location="section-container"
                    [iconButton]="true"
                    color="simple"
                    height="1"
                    shape="round"
                    appTooltip="Move Down"
                    toolTipOrigin="left"
                    [class.disabled]="!canMoveDown()"
                    (click)="moveDown()"
                  >
                    <app-svg src="/assets/icons/chevron-down.svg"></app-svg>
                  </button>
                </div>
              </div>
            }
          </div>
        </app-sticky>
      } @else {
        <app-context-menu [options]="{ width: '320px', noSpacing: true }" [position]="'right'" #mobileSectionOptions>
          <button
            appButton
            name="section-contols"
            location="section-container"
            class="mobile-section-controls-button"
            [iconButton]="true"
            height="0"
            shape="round"
            contextButton
          >
            <app-svg src="/assets/icons/16/section-middle.svg" size="-1"></app-svg>
          </button>
          <div contextContent class="button-menu">
            @if (mobileSectionOptions.isOpen()) {
              <ng-container *ngTemplateOutlet="templateActionsOutside"></ng-container>
              <ng-container *ngTemplateOutlet="templateActionsInside"></ng-container>

              <div class="divider"></div>

              <button
                appButton
                name="add-section-below"
                location="section-container"
                height="1"
                fullWidth="true"
                color="simple"
                [hasIcon]="true"
                (click)="addSection.emit(1); mobileSectionOptions.close()"
              >
                <app-svg src="/assets/icons/section-bot-add.svg"></app-svg>
                <span>Add new</span>
              </button>

              @if (canMoveUp() || canMoveDown()) {
                <button
                  appButton
                  name="move-up"
                  location="section-container"
                  height="1"
                  fullWidth="true"
                  color="simple"
                  [hasIcon]="true"
                  [class.disabled]="!canMoveUp()"
                  (click)="moveUp(); mobileSectionOptions.close()"
                >
                  <app-svg src="/assets/icons/chevron-up.svg"></app-svg>
                  <span>Move up</span>
                </button>
                <button
                  appButton
                  name="move-down"
                  location="section-container"
                  height="1"
                  fullWidth="true"
                  color="simple"
                  [hasIcon]="true"
                  [class.disabled]="!canMoveDown()"
                  (click)="moveDown(); mobileSectionOptions.close()"
                >
                  <app-svg src="/assets/icons/chevron-down.svg"></app-svg>
                  <span>Move down</span>
                </button>
              }

              <button
                appButton
                name="delete"
                location="section-container"
                height="1"
                fullWidth="true"
                color="simple-warn"
                [hasIcon]="true"
                (click)="deleteSection(); mobileSectionOptions.close()"
              >
                <app-svg src="/assets/icons/trash.svg"></app-svg>
                <span>Delete</span>
              </button>
            }
          </div>
        </app-context-menu>
      }
    }
    <div
      class="section-content-inner"
      #sectionContentInner
      [class.no-padding]="section().object === 'asset'"
      [style.position]="sectionContentInnerPosition"
      [style.max-width]="maxWidth() + 'px'"
    >
      @if (section().object !== 'text' && (section().text_title || section().text_paragraph)) {
        <app-edit-section-text
          [section]="section()"
          [gallery]="gallery"
          [theme]="theme()"
          [darkBackground]="darkBackground"
          [galleryPermissions]="galleryPermissions()"
          [class.with-padding]="section().object === 'asset'"
        ></app-edit-section-text>
      }

      <ng-content select="[sectionContent]"></ng-content>
    </div>
  </div>

  @if (galleryPermissions().can_edit && isDesktop) {
    <app-add-section
      [darkBackgroundColor]="darkBackground"
      [backgroundColor]="section().layout_background_color || theme().layout_page.background_color"
      [gallery]="gallery"
      [visible]="hover || inferredHover"
      testId="create-section"
      (onOpen)="addSection.emit(1)"
    ></app-add-section>
  }
</div>
